/**
 * Operations wrapper — 운영 메트릭 / 실시간 접속 / 감사 로그.
 *
 * sub 는 사이드바 2차 메뉴가 결정. 여기는 라우팅만 담당.
 */

import { MetricsPage } from './platform/Metrics';
import { AgentsPage } from './platform/Agents';
import { ActivityPage } from './Activity';

export type OperationsSub = 'metrics' | 'agents' | 'activity';

export function OperationsPage({ sub }: { sub: OperationsSub }) {
  if (sub === 'metrics') return <MetricsPage />;
  if (sub === 'agents') return <AgentsPage />;
  return <ActivityPage />;
}
